module.exports = __webpack_public_path__ + "img/pr-4.2f9df661.png";